import React, { useContext, useState } from "react";
import { Text } from "rizzui/typography";
import cn from "../../../lib/utils/class-name";
import { billingColumns } from "./column";
import { Button } from "rizzui/button";
import Table from "../../../component/table";
import { ActionIcon } from "rizzui/action-icon";
import { Input } from "rizzui/input";
import { inputClassName, labelClassName } from "../../projects/new/first";
import { set, useForm } from "react-hook-form";
import { Radio } from "rizzui/radio";
import { useModal } from "../../../hooks/useModal";
import DontEnable from "../../../component/dontEnable";
import FundWallet from "../../../component/fundWallet";
import UseCoupon from "../../../component/useCoupon";
import { AuthContext } from "../../../context/authContext";
import { usePaymentHistory } from "../../../hooks/usePayments";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import AddCardForm from "../../../component/addCard";
import AddCardPrompt from "../../../component/fundWalletPrompt";
import axios from "axios";
import { baseUrl } from "../../account/login";
import { useNotifcication } from "../../../hooks/useNotification";

function CardContainer({ children, className }) {
  return (
    <div
      className={cn(
        "grid-cols-1 border-[.5px] border-[#D1D6DD] w-full h-[110px] md:h-[150px] rounded-[8px] place-content-center pl-[10px] lg:pl-[20px]",
        className
      )}
    >
      {children}
    </div>
  );
}
const subtitleClassName =
  "font-[400] font-switzer text-[12px] md:text-[15px] md:leading-[22px] text-[#758599]";
const titleClassName = "font-[500] font-switzer text-[20px] leading-[26.4px]";

export default function Billing() {
  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
    setValue,
    resetField,
  } = useForm({
    defaultValues: {
      auto_reload: "enable",
      amount: "",
      minimum_amount: "",
    },
  });

  const { data: billingData, error, isLoading } = usePaymentHistory();
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK_VALUE ?? "");
  const handleSave = handleSubmit((data) => {
    console.log(data);
  });

  const { openNotification } = useNotifcication();

  const { profile, cardDetails, token } = useContext(AuthContext);
  const [paystackLoading, setPaystackloading] = useState(false);

  const enable = () => setValue("auto_reload", "enable");
  const dont_enable = () => {
    setValue("auto_reload", "dont_enable");
    resetField("minimum_amount");
    resetField("amount");
  };

  const getPayStackUrl = () => {
    setPaystackloading(true);
    axios
      .get(`${baseUrl}/payments/paystack/get_authorization_url`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data?.data?.authorization_url) {
          window.location.href = res.data?.data?.authorization_url;
        } else {
          openNotification({
            message:
              res.data?.data?.authorization_url?.message ||
              "Error fetching Payment URL",
            status: "error",
          });
        }
      })
      .catch((error) => {
        setPaystackloading(false);
        openNotification({
          message:
            error?.response?.data?.message || "Error fetching Payment URL",
          status: "error",
        });
      });
  };

  const { openModal } = useModal();

  return (
    <div className="mt-[49px]">
      <div className="w-full min-h-[150px] h-auto gap-[16px] grid grid-cols-1 place-items-center md:place-items-start md:grid-cols-2">
        <div className="w-full">
          <div className="flex gap-2">
            <CardContainer className={"bg-primary-dark dark:bg-btn"}>
              <Text className="text-background font-[600] font-switzer text-[28px] md:text-[36px] md:leading-[47.52px]">
                {profile?.user_currency_symbol}
                {profile?.wallet[0]?.balance?.toFixed(2) || "0"}
              </Text>
              <Text className={cn(subtitleClassName, "text-background")}>
                Wallet balance
              </Text>
            </CardContainer>
            <CardContainer className={"bg-background"}>
              <Text
                className={cn(
                  "text-primary-dark font-[600] font-switzer",
                  "text-[28px] md:text-[36px] md:leading-[47.52px]"
                )}
              >
                {profile?.user_currency_symbol}0
              </Text>
              <Text className={cn(subtitleClassName)}>
                Amount spent this month
              </Text>
            </CardContainer>
          </div>

          <div className="mt-4 flex gap-2">
            <ActionIcon
              className="!bg-btn w-full h-[40px]"
              onClick={() =>
                Object.keys(cardDetails?.data)?.length > 0
                  ? openModal({ view: <FundWallet /> })
                  : openModal({ view: <AddCardPrompt /> })
              }
            >
              <Text className="font-[500] text-[12px] text-background font-switzer">
                Fund Wallet
              </Text>
            </ActionIcon>

            <ActionIcon
              className="!bg-[#F2F2F2] dark:!bg-muted w-full h-[40px]"
              onClick={() => openModal({ view: <UseCoupon /> })}
            >
              <Text className="font-[500] text-[12px] text-[#191919] dark:text-[#D9D9D9] font-switzer">
                Apply coupon
              </Text>
            </ActionIcon>
          </div>

          <div className="mt-4 h-fit border-dashed border border-[#758599] rounded-[4px] p-[32px]">
            <form
              className="flex flex-col gap-[20px] "
              noValidate
              onSubmit={(e) => {
                e.preventDefault();
                handleSave();
              }}
            >
              <div className="flex flex-col gap-[16px]">
                <Text className={labelClassName}>
                  Auto reload when your wallet balance is low
                </Text>
                <div className="flex gap-[24px]">
                  <Radio
                    label="Enable"
                    value="enable"
                    size="sm"
                    labelClassName={cn(
                      labelClassName,
                      "!text-primary-dark ml-[16px]"
                    )}
                    {...register("auto_reload", {
                      required: true,
                    })}
                  />

                  <Radio
                    label="Don't enable"
                    size="sm"
                    value="dont_enable"
                    labelClassName={cn(
                      labelClassName,
                      "!text-primary-dark ml-[16px]"
                    )}
                    {...register("auto_reload", {
                      required: true,
                    })}
                    onChange={(e) => {
                      e.preventDefault();
                      openModal({
                        view: (
                          <DontEnable
                            enable={enable}
                            dont_enable={dont_enable}
                          />
                        ),
                      });
                    }}
                  />
                </div>

                {errors.auto_reload?.message && (
                  <p className="text-red text-[13px]">{"Select an option"}</p>
                )}
              </div>
              <Input
                label="Amount to fund"
                type="number"
                inputClassName={inputClassName}
                labelClassName={labelClassName}
                prefixClassName="-mr-2 font-switzer text-[12px]"
                prefix={profile?.user_currency_symbol}
                {...register("amount", { required: "Required" })}
                error={errors?.amount ? "Required" : ""}
              />

              <Input
                label="Notify me when when my balance reaches"
                type="number"
                inputClassName={inputClassName}
                labelClassName={labelClassName}
                prefixClassName="-mr-2 font-switzer text-[12px]"
                prefix={profile?.user_currency_symbol}
                {...register("minimum_amount", { required: "Required" })}
                error={
                  errors?.minimum_amount?.message
                    ? "" + errors?.minimum_amount?.message
                    : ""
                }
              />
              {watch("auto_reload") === "enable" && (
                <ActionIcon
                  type="submit"
                  className="!bg-btn w-[158px] h-[40px] rounded-[4px] self-end"
                >
                  <Text className="text-background font-switzer text-[12px] font-[500]">
                    Save changes
                  </Text>
                </ActionIcon>
              )}
            </form>
          </div>
        </div>
        <div className="w-full h-full">
          <div className="bg-[#E3E7EB] dark:bg-muted w-full h-[100px] place-content-start pt-[24px] px-[33px]">
            <div className="flex justify-between">
              <div className="flex flex-col gap-[12px]">
                <Text
                  className={cn(
                    "text-primary-dark font-[600] !text-[15px] font-switzer",
                    titleClassName
                  )}
                >
                  {cardDetails?.data?.last4
                    ? `******${cardDetails?.data?.last4}`
                    : "No card added yet"}
                </Text>
                <Text className={cn(subtitleClassName, "dark:!text-[#D9D9D9]")}>
                  Payment method (Card)
                </Text>
              </div>
              <Button
                variant="text"
                className="bg-transparent p-0 m-0"
                isLoading={paystackLoading}
                onClick={() =>
                  profile?.user_currency === "NGN"
                    ? getPayStackUrl()
                    : openModal({
                        view: (
                          <Elements stripe={stripePromise}>
                            <AddCardForm />
                          </Elements>
                        ),
                      })
                }
              >
                <Text
                  className="font-[500] font-switzer text-[15px]
                    underline text-[#191919]"
                >
                  {cardDetails?.data?.last4 ? "Change" : "Add your card"}
                </Text>
              </Button>
            </div>
          </div>

          <div className="h-[calc(100%-100px)] rounded-b-[4px] flex flex-col gap-[24px] border-muted border py-[24px] px-[33px] border-t-0">
            <Text className="font-[600] text-primary-dark font-ibmPlexSerif text-[15px] leading-[22px]">
              Payment history
            </Text>

            <Table
              data={billingData?.data || []}
              columns={billingColumns}
              pageSize={undefined}
              setPage={() => {}}
              meta={() => {}}
              isLoading={false}
              error={undefined}
              billing={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export function NewClient() {
  return (
    <div className="mt-[49px]">
      <div className="absolute bottom-[10px] w-full h-[168px] px-[16px]">
        <div className="bg-[#191919] dark:bg-[#2A2C30] rounded-[8px] h-full p-[16px] flex flex-col justify-between">
          <div>
            <Text className="font-ibmPlexSerif text-[#758599] font-[400] leading-[18.2px] text-[14px]">
              Remaining credit
            </Text>

            <Text className="font-switzer text-[#FFFFFF] font-[500] leading-[31.68px] text-[24px]">
              $9.34
            </Text>
          </div>
          <div className="w-full">
            <div className="w-full justify-between">
              <Text className="font-switzer text-[#758599] font-[400] leading-[15.84px] text-[12px] py-1">
                Upgrade to $0.60/min
              </Text>

              <Text className="font-switzer text-[#758599] font-[400] leading-[15.84px] text-[12px] py-1">
                Billed monthly
              </Text>
            </div>
            {}
            <Button
              variant="flat"
              className="bg-[#FFFFFF] hover:bg-[#FFFFFF] font-switzer font-[400] leading-[15.84px] text-[12px] hover:text-[#2A2C30] w-full"
            >
              Upgrade now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
